module.exports = __webpack_public_path__ + "img/tron (68).5881c883.jpg";